import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ITranslator } from 'types/common';

const AppIntl: React.FC = () => {
	const intl = useIntl();

	global.intl = useMemo<ITranslator>(
		() => ({
			...intl,
			tr: (id: string, values?: any, defaultMessage?: string) =>
				intl.formatMessage({ id, defaultMessage }, values),
			formatDateTime: (rawTime?: any) => {
				if (!rawTime) {
					return intl.formatMessage({ id: 'app.na' });
				}
				const parts = intl.formatDate(rawTime, { year: 'numeric' });
				let readyTime = rawTime;
				if (parts === '1970') {
					readyTime *= 1000;
				}
				return `${intl.formatDate(readyTime, {
					year: 'numeric',
					month: 'long',
					day: '2-digit'
				})}
					${intl.formatTime(readyTime, {
						hour12: false
					})}`;
			}
		}),
		[intl]
	);

	return null;
};

export default AppIntl;
